// import { configureStore } from "@reduxjs/toolkit";
// import userReducer from "./features/userSlice"
// import trackHRReducer from "./features/trackhrdataslice"
// import trackhrCategory from "./features/categoryslice"
// import userData from "./features/UserDataslice"
// export const store = configureStore({
//   reducer: {
//     users: userReducer,
//     trackhrdata: trackHRReducer,
//     trackhrcategory:trackhrCategory,
//     userData:userData
//   },
//    devTools: process.env.NODE_ENV !== "production"
// });

import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer"; 

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production"
});

